<template>
  <RModal ref="modal" :title="modalTitle" @cancel="$event()" @ok="save">
    <q-select
      v-model="selectedStakeholder"
      :options="stakeholderOptions"
      :option-disable="option => stakeholder && option.value === stakeholder.id"
      outlined
      label="Transfer to:"
      hint="Select stakeholder to transfer stakes to"
      class="q-pt-lg"
    />
  </RModal>
</template>

<script>
import * as apiTo from '@/modular-api'
// Components
import RModal from '@/ui/RModal'

export default {
  components: {
    RModal
  },

  props: {
    stakeholders: Array
  },

  data: () => ({
    selectedStakeholder: null,
    stakeholder: null
  }),

  computed: {
    stakeholderOptions() {
      if (!this.stakeholder) return []

      return this.stakeholders.map(stakeholder => ({
        value: stakeholder.id,
        label: `${stakeholder.first_name} ${stakeholder.last_name}`
      }))
    },

    modalTitle() {
      if (!this.stakeholder) return ''
      return `Transfer stakes from ${this.stakeholder.first_name} ${this.stakeholder.last_name}`
    }
  },

  methods: {
    show(stakeholder) {
      this.selectedStakeholder = null
      this.stakeholder = stakeholder
      this.$refs.modal.show()
    },

    save(hideModal, setModalLoading) {
      if (!this.selectedStakeholder) return

      setModalLoading()

      apiTo
        .REPLACE_STAKEHOLDER(this.stakeholder.id, this.selectedStakeholder.value)
        .then(res => {
          this.$store.dispatch(
            'createNotificationToast',
            {
              message: res.data.messages.default,
              color: res.data.status
            },
            { root: true }
          )
          hideModal()
        })
        .finally(() => setModalLoading(false))
    }
  }
}
</script>
